import loadable from "@loadable/component";

export const BizkeyApprovalList = loadable(() => import("./approval/list"));
export const BizkeyApprovalDetail = loadable(() => import("./approval/detail"));
